const appendStylesheet = (id, styles) => {
  let styleSheet = document.head.querySelector(`#${id}`);
  if (!styleSheet) {
    styleSheet = document.createElement("style");
    styleSheet.id = id;
    styleSheet.innerHTML = styles;
    document.head.appendChild(styleSheet);
  }
};
export {
  appendStylesheet
};
//# sourceMappingURL=light-dom-styles.js.map
